import { toast } from "react-toastify";
import { ToastNotification } from "./ToastNotification";

export default function useNotifications() {
    /**
     *
     * @param {Object} notification The notification content.
     * @param {string} [notification.title] The notification title.
     * @param {string} notification.message The notification message content.
     */
    const toastContent = { hideProgressBar: true, autoClose: 3000 };

    const success = (notification) => {
        toast.success(ToastNotification, {
            ...toastContent,
            data: {
                title: notification?.title,
                content: notification.message,
            },
        });
    };

    const info = (notification) => {
        toast.info(ToastNotification, {
            ...toastContent,
            data: {
                title: notification?.title,
                content: notification.message,
            },
        });
    };
    /**
     *
     * @param {Object} notification The notification error content.
     * @param {string} [notification.title] The notification title.
     * @param {string} notification.message The notification message content.
     */
    const error = (notification) => {
        toast.error(ToastNotification, {
            ...toastContent,
            data: {
                title: notification?.title,
                content: notification.message,
            },
        });
    };

    return {
        success,
        info,
        error,
    };
}
